import { render, staticRenderFns } from "./product-pvlayout.vue?vue&type=template&id=7cf9f0c4&scoped=true"
import script from "./product-pvlayout.vue?vue&type=script&lang=js"
export * from "./product-pvlayout.vue?vue&type=script&lang=js"
import style0 from "./product-pvlayout.vue?vue&type=style&index=0&id=7cf9f0c4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf9f0c4",
  null
  
)

export default component.exports